export default "__VITE_ASSET__ClNC59uJ__"